module.exports = __webpack_public_path__ + "img/magic-wand.e67abb44.svg";